import {Guid} from "guid-typescript";
import ProjectFile from "@/models/entities/ProjectFile";
import OldProjectFile from "@/models/entities/old/ProjectFile";
import ServiceConfig from "@/models/entities/ServiceConfig";
import {chunkSize} from "@/AppConfig";

export class GeneralOldRequest {
    requestId: Guid = Guid.create();
}

export class UploadRequest extends GeneralOldRequest {
    uploadID:string|null;
    ticketGuid:string|null;
    fileName:string;
    fK_UserID:number;
    fileSize:number;
    fileType:string;
    blockIndexLimit:number;
    uploadedBytes:number;
    isCompleted:boolean;
    messageToCreator:string|null;

    constructor(file:ProjectFile, ticketGuid:string|null = null) {
        super();
        this.uploadID = file.downloadToken ?? null;
        this.ticketGuid = ticketGuid;
        this.fileName = file.name;
        this.fK_UserID = file.owner.userId!;
        this.fileSize = file.sizeInBytes!;
        this.fileType = file.type;
        this.blockIndexLimit = Math.ceil(file.sizeInBytes/chunkSize);
        this.uploadedBytes = 0;
        this.isCompleted = false;
        this.messageToCreator = file.messageToCreator ?? null;
    }
}

export class OldUploadRequest extends GeneralOldRequest {
    uploadID:string|null;
    ticketGuid:string|null;
    fileName:string;
    fK_UserID:number;
    fileSize:number;
    fileType:string;
    blockIndexLimit:number;
    uploadedBytes:number;
    isCompleted:boolean;
    messageToCreator:string|null;

    constructor(file:OldProjectFile, ticketGuid:string|null = null) {
        super();
        this.uploadID = file.urlGuid ?? null;
        this.ticketGuid = ticketGuid;
        this.fileName = file.name;
        this.fK_UserID = file.creatorId!;
        this.fileSize = file.size!;
        this.fileType = file.type;
        this.blockIndexLimit = Math.ceil(file.size!/chunkSize);
        this.uploadedBytes = 0;
        this.isCompleted = false;
        this.messageToCreator = file.messageToCreator ?? null;
    }
}

export class GuestRequest extends GeneralOldRequest {
    guid:string;
    authMail:string;
    otp:string|null;

    constructor(guid:string, authMail:string, otp:string|null=null) {
        super();
        this.guid = guid;
        this.authMail = authMail;
        this.otp = otp;
    }
}

export class StaticTicketRequest extends GeneralOldRequest {
    guid:string;
    password:string;

    constructor(guid:string, password:string) {
        super();
        this.guid = guid;
        this.password = password;
    }
}
